
import { defineComponent, PropType } from 'vue'
import { gradeIcon } from '~/utils/ui'

const gradeVariants = ['A', 'B', 'C', 'D'] as const
type GradeVariant = (typeof gradeVariants)[number]

export default defineComponent({
  name: 'UIReportCardGrade',
  props: {
    grade: {
      type: String as PropType<GradeVariant>,
      required: true,
      validator: (value: GradeVariant) => gradeVariants.includes(value)
    }
  },
  computed: {
    icon(): string {
      return gradeIcon(this.grade)
    }
  }
})
